import { logger } from 'src/utils/logger';
import type { Message } from './useChatbotLogic';
import { STORAGE_KEYS } from './constants';

const MAX_MESSAGES = 50;

export function isAvailable(): boolean {
	try {
		const testKey = '__chatbot_storage_test__';
		sessionStorage.setItem(testKey, '1');
		sessionStorage.removeItem(testKey);
		return true;
	} catch {
		return false;
	}
}

export function saveMessages(messages: Message[]): void {
	try {
		const trimmed = messages.length > MAX_MESSAGES ? messages.slice(-MAX_MESSAGES) : messages;
		sessionStorage.setItem(STORAGE_KEYS.MESSAGES, JSON.stringify(trimmed));
	} catch (error) {
		logger.warn('Failed to save messages to sessionStorage', { error });
	}
}

export function loadMessages(): Message[] | null {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEYS.MESSAGES);
		if (!raw) return null;
		return JSON.parse(raw) as Message[];
	} catch (error) {
		logger.warn('Failed to load messages from sessionStorage', { error });
		return null;
	}
}

export function saveSession(sessionId: string, actorId: string): void {
	try {
		sessionStorage.setItem(STORAGE_KEYS.SESSION_ID, sessionId);
		sessionStorage.setItem(STORAGE_KEYS.ACTOR_ID, actorId);
	} catch (error) {
		logger.warn('Failed to save session to sessionStorage', { error });
	}
}

export function loadSession(): { sessionId: string; actorId: string } | null {
	try {
		const sessionId = sessionStorage.getItem(STORAGE_KEYS.SESSION_ID);
		const actorId = sessionStorage.getItem(STORAGE_KEYS.ACTOR_ID);
		if (!sessionId || !actorId) return null;
		return { sessionId, actorId };
	} catch (error) {
		logger.warn('Failed to load session from sessionStorage', { error });
		return null;
	}
}

export function clearAll(): void {
	try {
		sessionStorage.removeItem(STORAGE_KEYS.MESSAGES);
		sessionStorage.removeItem(STORAGE_KEYS.SESSION_ID);
		sessionStorage.removeItem(STORAGE_KEYS.ACTOR_ID);
	} catch (error) {
		logger.warn('Failed to clear sessionStorage', { error });
	}
}
